import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [authLoading, setAuthLoading] = useState(true); // Status loading

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        // Pengguna logout
        setUser(null);
        setRoles([]);
        setPhoneNumber('');
      } else {
        // Pengguna login, ambil data peran dari Firestore
        const userDocRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          setRoles(userDoc.data().roles || ['member']);
        } else {
          // Jika dokumen pengguna belum ada, buat dengan peran default 'member'
          await setDoc(userDocRef, { 
            roles: ['member'],
            phoneNumber: currentUser.phoneNumber,
            createdAt: serverTimestamp(),
            phoneNumberVerifiedAt: serverTimestamp()
          });
          setRoles(['member']);
        }
        setUser(currentUser);
        setPhoneNumber(currentUser.phoneNumber);
      }
      // Tandai bahwa proses inisialisasi otentikasi selesai
      setAuthLoading(false);
    });
    return unsubscribe;
  }, [auth]);

  const verifyOtp = async (confirmationResult, otp) => {
    if (!confirmationResult) throw new Error("Hasil konfirmasi tidak tersedia.");
    return await confirmationResult.confirm(otp);
  };

  const signOut = () => {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = null;
    }
    firebaseSignOut(auth);
  };

  const value = { user, roles, phoneNumber, auth, authLoading, verifyOtp, signOut };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
